import { render, staticRenderFns } from "./TagManager.vue?vue&type=template&id=57161b02&"
import script from "./TagManager.vue?vue&type=script&lang=js&"
export * from "./TagManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports